import PropTypes from 'prop-types';

// The WhatsApp KPI cards are placeholders: every metric is "Coming Soon" and there is no
// data behind them. Rather than overlaying a card shell with a badge (noise on a page that
// is meant to be simple), the whole section is hidden until real metrics are wired in.
// The previous KPI_CONFIGS (conversations / active / closed / response time / within 24hr)
// live in git history; rebuild them on StatCard when the data exists.
const WhatsAppKPICards = () => null;

export default WhatsAppKPICards;

WhatsAppKPICards.propTypes = {
    // eslint-disable-next-line react/no-unused-prop-types
    data: PropTypes.object,
};

WhatsAppKPICards.defaultProps = {
    data: undefined,
};
